import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { runStatuses } from '@dbt-labs/dbt-dag';
import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { RunStatus } from '@/__generated__/graphql';
import { toTitleCase } from '@/util/string';

export type StatusFilterDropdownProps = {};

export const RUN_STATUS_PARAM = 'status';

export const StatusFilterDropdown: FC<StatusFilterDropdownProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...runStatuses.map(
        (status): DropdownOption => ({ label: toTitleCase(status), value: status }),
      ),
    ],
    [],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const qsValue = searchParams.get(RUN_STATUS_PARAM) as RunStatus | undefined;
    return options.find((o) => o.value === qsValue) || options[0];
  }, [searchParams, options]);

  return (
    <DropdownButton
      options={options}
      name={'Status'}
      defaultOption={defaultOption}
      listClassName="z-50"
      onChange={({ value }) => {
        if (typeof value !== 'string') return;
        if (value === 'all') {
          setSearchParams((p) => {
            p.delete(RUN_STATUS_PARAM);
            return p;
          });
        } else {
          setSearchParams((p) => {
            p.set(RUN_STATUS_PARAM, value);
            return p;
          });
        }
      }}
    />
  );
};
